import MenuList from "@/components/MenuList/MenuList.vue"
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'SidebarMobileMenu',
    data() {
        return {
            list1: {
                title: 'MENU',
                data: [
                    {id: 1, title: 'My gates', to: '/my-gates'},
                    {id: 2, title: 'Pricing', to: '/pricing'},
                    {id: 3, title: 'Support', to: '/support'},
                ]
            },
            visibleB: true,
            flag: true,
            showMenu: false,
            tooltipDropdown: [
                {option: 'Profile settings', href: "/profile-settings"},
            ],
        }
    },
    props: ['openMenu'],
    components: {
        MenuList
    },
    methods: {
        ...mapActions([
            'changeVision'
        ]),
        // hideMenu() {
        //     this.showMenu = false
        //     this.$emit('setMenuStatus', this.showMenu)
        // },
        visibleBubble() {
            this.visibleB = !this.visibleB
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
            this.$emit('setMenuStatus', this.showMenu)
        },
        logout() {
            this.$store.dispatch('logout').then(resp => {
                this.$router.push('/')
                //document.location.reload();
            });
            if (this.isLogByFB) {
                this.$store.dispatch('logoutFB')
            }
        },
    },
    computed: {
        ...mapGetters([
            'toggleSidebar', 'getRoutes', 'isLoggedIn',
            'userInfo', 'isLogByFB', 'getActivePlanId',
            'getEndTrial','getTrialPlanPeriod','getMaxAvailablePlans', 'getMenuStatus'
        ]),
        nowDate(){
            return Date.parse(new Date())
        }
    },
    watch: {
        openMenu() {
            this.showMenu = this.openMenu
        }
    }
}
